import { gql } from "apollo-boost";

export const GET_CLUB_INFO = gql`
  query($clubId: Int, $clubName: String) {
    allClub(clubId: $clubId, clubName: $clubName) {
      edges {
        node {
          leagueClubRels {
            edges {
              node {
                leagueSeqno
                league {
                  name
                }
              }
            }
          }
          clubId
          clubCode
          clubName
          clubDesc
          email
          countryId
          year
          userId
          visibility
          createDate
          latitude
          longitude
          website
          reviewsUrl
          facebookUrl
          instagramUrl
          xUrl
          tiktokUrl
          youtubeUrl
          discordUrl
          team {
            edges {
              node {
                teamName
                teamId
                year
                toYear
                visibility
                sportType
                logo
                orderOnUi
                competitiveFlag
                studentCoachRatio
                monthlyFee
                registrationFee
                fundrasingFee
                maxAthletes
                coaches
                teamDescription
                commitmentRequirements
                athlete {
                  edges {
                    node {
                      athleteId
                      firstName
                      lastName
                      teamId
                      status
                      gender
                      email
                      participationDays
                      attendance {
                        edges {
                          node {
                            attendanceId
                            workoutId
                            effectiveDate
                            missed
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_CLUBS = gql`
  query($clubId: Int, $clubName: String) {
    allClub(clubId: $clubId, clubName: $clubName) {
      edges {
        node {
          clubId
          clubCode
          clubName
          clubDesc
          logo
          email
          visibility
          countryId
          createDate
          year
          userId
          email
          website
          reviewsUrl
          facebookUrl
          instagramUrl
          xUrl
          tiktokUrl
          youtubeUrl
          discordUrl
          team {
            edges {
              node {
                teamName
                teamId
                year
                toYear
                visibility
                sportType
                logo
                competitiveFlag
                studentCoachRatio
                monthlyFee
                registrationFee
                fundrasingFee
                maxAthletes
                coaches
                teamDescription
                commitmentRequirements
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_EVENT_CATALOG = gql`
query allEventCatalog($orgId: Int, $name: String) {
  allEventCatalog(orgId: $orgId, name: $name) {
    edges {
      node {
          eventId		
          orgType		
          visibility	
          orgId		
          name		
          eventType	
          status		
          startDate	
          endDate		
          description	
          facilityId	
          urlToDetails
          createDate	
          updateDate	
          updateSource
      }
    }
  }
}
`;